export default "__VITE_ASSET__sI$hsePr__"